export const routes = [
    {
        groupName: 'menu-1',
        routes: [
            {
                menuId: 'RPT-LIS200',
                menuName: 'Report Legacy Monitoring',
                pathname: '/legacyreport',
            },
            {
                menuId: 'RPT-LIS201',
                menuName: 'Report Legacy Manual',
                pathname: '/legacyreport-manual',
            },
            {
                menuId: 'RPT-LIS202',
                menuName: 'Report Legacy Task Monitoring',
                pathname: '/legacytask',
            },
            {
                menuId: 'RPT-LIS203',
                menuName: 'System Log',
                pathname: '/legacylog',
            },
            {
                menuId: 'RPT-LIS204',
                menuName: 'Quartz Monitor',
                pathname: '/quartzmonitor',
            },
            {
                menuId: 'RPT-LIS205',
                menuName: 'Create Structure',
                pathname: '/uploadfileconfig',
            },
            {
                menuId: 'RPT-LIS206',
                menuName: 'Download Source And Response File',
                pathname: '/downloadsourceandresponsefile',
            },
            {
                menuId: 'RPT-LIS207',
                menuName: 'Application Log',
                pathname: '/applicationlog',
            },
        ]
    },
    {
        groupName: 'menu-2',
        routes: [
            {
                menuId: 'ADM-LIS300',
                menuName: 'Job Config',
                pathname: '/masterconfig',
            },
            {
                menuId: 'ADM-LIS301',
                menuName: 'Pull Job Config',
                pathname: '/pulljobconfig',
            },
            {
                menuId: 'ADM-LIS302',
                menuName: 'Pull job Config Log',
                pathname: '/pulljobconfig-log',
            },
            {
                menuId: 'ADM-LIS303',
                menuName: 'API Config',
                pathname: '/companyconfig',
            },
            {
                menuId: 'ADM-LIS304',
                menuName: 'sFTP Config',
                pathname: '/sftpconfig',
            },
            {
                menuId: 'ADM-LIS305',
                menuName: 'DMS Config',
                pathname: '/dmsconfig',
            },
            {
                menuId: 'ADM-LIS306',
                menuName: 'DMS Bucket Image Doc Type Config',
                pathname: '/dms-bucket-config',
            },
            {
                menuId: 'ADM-LIS307',
                menuName: 'DMS Bucket Company Code Config',
                pathname: '/dms-bucket-company-code-config',
            },
            {
                menuId: 'ADM-LIS308',
                menuName: 'Menu Master Config',
                pathname: '/legacy-menu-master-config',
            },
            {
                menuId: 'ADM-LIS309',
                menuName: 'Role Master Config',
                pathname: '/legacy-role-master-config',
            },
            {
                menuId: 'ADM-LIS310',
                menuName: 'Employee Roles',
                pathname: '/employee-roles',
            },
            {
                menuId: 'ADM-LIS311',
                menuName: 'Employee Config',
                pathname: '/employee',
            },
            {
                menuId: 'ADM-LIS312',
                menuName: 'Email Content',
                pathname: '/emailcontent',
            },
            {
                menuId: 'ADM-LIS313',
                menuName: 'Config Log',
                pathname: '/config-log',
            },
        ]
    }
];

export const flatRoutes = routes.flatMap(routeGroup => routeGroup.routes);
